import { connect } from "react-redux";
import ConceptStatus from "../components/FileManager/ConceptStatus";

const mapStateToProps = state => {
  return {
    saving: state.filemanager.loading.command,
    dirty: state.filemanager.isDirty,
    conceptName: state.filemanager.workingConcept,
    autoSave: state.preferences.autoSave
  };
};

export default connect(mapStateToProps, null)(ConceptStatus);
